import type {
  ApiResponse,
  Professional,
  ProfessionalDashboardStats,
  UpdateProfessionalPayload,
  UpdateServiceChannelsPayload,
} from '@klaro7/shared-types';

import api from '@/lib/api';

export async function getMyProfessionalProfile(): Promise<Professional> {
  const response = await api.get<ApiResponse<Professional>>('/professionals/me');
  return response.data.data;
}

export async function getMyDashboardStats(): Promise<ProfessionalDashboardStats> {
  const response = await api.get<ApiResponse<ProfessionalDashboardStats>>('/professionals/me/stats');
  return response.data.data;
}

export async function updateMyProfessionalProfile(
  data: UpdateProfessionalPayload
): Promise<Professional> {
  const response = await api.put<ApiResponse<Professional>>('/professionals/me', data);
  return response.data.data;
}

export async function updateMyServiceChannels(
  data: UpdateServiceChannelsPayload
): Promise<Professional> {
  const response = await api.patch<ApiResponse<Professional>>(
    '/professionals/me/service-channels',
    data
  );
  return response.data.data;
}

export async function setMyIban(iban: string): Promise<Professional> {
  const response = await api.put<ApiResponse<Professional>>('/professionals/me/iban', { iban });
  return response.data.data;
}

export async function uploadAvatar(file: File): Promise<string> {
  const formData = new FormData();
  formData.append('avatar', file);
  const response = await api.post<ApiResponse<{ url: string }>>(
    '/professionals/me/avatar',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data.data.url;
}

export async function changePassword(
  currentPassword: string,
  newPassword: string
): Promise<void> {
  await api.put('/professionals/me/password', { currentPassword, newPassword });
}

export async function updateMyUserProfile(data: {
  firstName?: string;
  lastName?: string;
  artFirstName?: string;
  artLastName?: string;
  phone?: string;
  bio?: string;
}): Promise<void> {
  await api.put('/professionals/me/user-profile', data);
}

export async function submitForReview(): Promise<void> {
  await api.patch('/professionals/me/submit-review');
}
